<div class="w-100 d-flex justify-content-between py-6">
  <hr class="w-100">
  <h1 class="w-25 text-center" translate>Reponses</h1>
  <hr class="w-100">
</div>
<div  class="card mb-5 w-100  mx-auto  content flex-row-fluid pt-4 ">
  <ng-container *ngFor="let item of data$ | async " > 
    <div class="m-5 d-flex justify-content-between align-items-center bg-light p-4" >
      <span class="fw-bold highlighted" >{{item}}</span>
    </div>
  </ng-container>
</div>
